export function servicesAccordion() {
    let $accordionLink = $(".services .accordion h3 a");
    $accordionLink.on("click", function () {
        if (!$(this).parent().hasClass("active")) {
            $accordionLink.parent().removeClass("active").next(".info").slideUp(350, function () {
                $(this).removeClass("active");
            });
            $(this).parent().addClass("active").next(".info").slideDown(350, function () {
                $(this).addClass("active");
            });
        }
        return false;
    });
    $(".services .accordion h3:first a").trigger("click");
}



// WEBPACK FOOTER //
// ./assets/js/modules/servicesAccordion.js